import type { OptInStatusResponse } from "../apply/types"
import type { PublicStats } from "../types"

export type PromotionStanding =
  | { kind: "loading"; phase: "application" | "standing" }
  | { kind: "error"; phase: "application" | "standing" }
  | { kind: "not-applied" }
  | { kind: "syncing" }
  | { kind: "applied"; stats: PublicStats }

export function getPromotionStanding({
  accountId,
  optInStatus,
  optInLoading,
  optInError,
  stats,
  statsLoading,
  statsError,
  statsNotApplied,
}: {
  accountId?: string
  optInStatus?: OptInStatusResponse
  optInLoading: boolean
  optInError: boolean
  stats?: PublicStats
  statsLoading: boolean
  statsError: boolean
  statsNotApplied: boolean
}): PromotionStanding {
  if (!accountId) return { kind: "not-applied" }

  if (optInStatus?.status === "applied") {
    if (stats) return { kind: "applied", stats }
    if (statsNotApplied) return { kind: "syncing" }
    if (statsError) return { kind: "error", phase: "standing" }
    if (statsLoading) return { kind: "loading", phase: "standing" }
    return { kind: "syncing" }
  }

  if (optInStatus?.status === "not_applied") {
    return { kind: "not-applied" }
  }
  if (optInStatus?.status === "not_configured" || optInError) {
    return { kind: "error", phase: "application" }
  }
  if (optInLoading) return { kind: "loading", phase: "application" }
  return { kind: "loading", phase: "application" }
}

export function isAppliedPromotionStanding(
  standing: PromotionStanding
): boolean {
  return (
    standing.kind === "applied" ||
    standing.kind === "syncing" ||
    (standing.kind === "loading" && standing.phase === "standing") ||
    (standing.kind === "error" && standing.phase === "standing")
  )
}

export function formatPromotionRank(
  stats: Pick<PublicStats, "position" | "relative_message">
): string {
  const relativeMessage = stats.relative_message
    .trim()
    .replace(/^You are\s*/i, "")
    .replace(/\.+$/, "")
    .trim()

  return relativeMessage
    ? `You're ranked #${stats.position}, ${relativeMessage}.`
    : `You're ranked #${stats.position}.`
}
